<template>
	<RichText v-editable="blok" :data="document" />
</template>

<script setup lang="ts">
	import {isRichTextEditor} from '~/utils/richtextIsEmpty';
	import type {RichtextStoryblok, RichTextEditorStoryblok} from '@/storyblok/types';

	interface Props {
		blok: RichTextEditorStoryblok | RichtextStoryblok
	}

	const props = defineProps<Props>();

	const document = computed(() => (
		isRichTextEditor(props.blok) ? props.blok.content : props.blok
	));
</script>
